import React from 'react'
import { IntlProvider } from 'react-intl'
import { Provider as StoreProvider } from 'react-redux'
import store from '../store'
import { QueryClientProvider, QueryClient } from 'react-query'
import { AntConfigProvider } from '../Root'
import { locale, translations } from '../Locale'

const queryClient = new QueryClient()

const TooltipRoot = ({ children }) => {
  return (
    <StoreProvider store={store}>
      <AntConfigProvider>
        <QueryClientProvider client={queryClient}>
          <IntlProvider locale={locale} messages={translations}>
            {children}
          </IntlProvider>
        </QueryClientProvider>
      </AntConfigProvider>
    </StoreProvider>
  )
}

export default TooltipRoot
